import React, { useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { FlexCenter } from "../../../../../layout/FlexCenter/FlexCenter";
import IconComponent from "../../../../../shared/IconComponents/IconComponent";
import { ExecButton } from "../../../../../ui/ExecButton/ExecButton";
import { TextCustom } from "../../../../../ui/TextCustom";


interface IAiAnalyzerFileUploaderProps {
    func: (files: FileList) => void;
    
}
export const AiAnalyzerFileUploader: React.FC<IAiAnalyzerFileUploaderProps> = ({ func }) => {
    const [dragging, setDragging] = useState(false);
    
    const handleDraggingStateChange = (isDragging: boolean) => {
        setDragging(isDragging);
    }

    return (
    <FileUploader
        multiple
        handleChange={func}
        name={'file'}
        hoverTitle=" "
        label=""
        onDraggingStateChange={handleDraggingStateChange}
        dropMessageStyle={{ backgroundColor: 'transparent', border: 'none' }}
    >
        <div
            className={`dropbox ${dragging && 'animation-scale'}`}
            style={{
                width: '100%',
                height: '150px',
                backgroundColor: `${dragging ? 'rgb(237, 255, 211)' : '#fff'}`,
                border: `2px dashed ${dragging ? '#77b800' : '#797c7d'}`,
                borderRadius: '1rem',
            }}
        >
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <FlexCenter gap={1}>
                    <IconComponent size={3} iconName={'Drop'} />
                    <FlexCenter gap={0}>
                        <TextCustom color="dark">Drag and drop</TextCustom>
                        <TextCustom color="dark">or</TextCustom>
                    </FlexCenter>
                    <ExecButton size="s" iconSize={1.6} label={'Upload files'} iconName={'Submit'} func={() => console.log('Upload files...')} />
                </FlexCenter>
            </div>
        </div>
    </FileUploader>
    );
}